import React from 'react'
import './styles/buttonGroup.scss'

const ButtonGroup = (props) => {
    const {
        children, cssClass, style,
    } = props

    return (
        <div style={style} className={`uc-buttonGroup ${cssClass || ''}`}>
            {children}
        </div>
    )
}

export default ButtonGroup
